// extracted by mini-css-extract-plugin
export default {"action":"shared_action__0xRho"};